__turbopack_context__.v({
  "username": "UserAvatarSimple-module-scss-module__MfN7fW__username",
});
